import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
} from "@material-ui/core";
import TableRow from "@material-ui/core/TableRow";
import React from "react";
import { Fare } from "../Models";
import { formatDateEventualy } from "../utils";
import ListStyles from "./ListStyles";

interface Column {
  render: (fare: Fare) => string;
  title: string;
}

export const FareTable = (props: {
  fares: Fare[];
  onRowClick: (fare: Fare) => any;
}) => {
  const cols: Column[] = [
    {
      title: "Identifiant",
      render: (f) => f.identifier,
    },
    {
      title: "Demandeur",
      render: (f) => f.ordererId,
    },
    {
      title: "Patient",
      render: (f) =>
        [
          f.patientSex === "M" ? "M" : "Mme",
          f.patientFirstname,
          f.patientLastname,
        ].join(" "),
    },
    {
      title: "Transporteur",
      render: (f) => f.transporter,
    },
    {
      title: "Type",
      render: (f) => f.transportType,
    },
    {
      title: "Départ commande",
      render: (f) => formatDateEventualy(f.orderedLeaveDate),
    },
    {
      title: "Arrivée commande",
      render: (f) => formatDateEventualy(f.orderedArrivalDate),
    },
    {
      title: "Départ déclaré",
      render: (f) => formatDateEventualy(f.realStartDate),
    },
    {
      title: "Arrivée déclarée",
      render: (f) => formatDateEventualy(f.realEndDate),
    },
    {
      title: "Etab départ",
      render: (f) => f.departureHC || "",
    },
    {
      title: "Etab arrivée",
      render: (f) => f.arrivalHC || "",
    },
    {
      title: "Adresse départ",
      render: (f) => {
        return [
          f.departure.placeName,
          f.departure.address,
          f.departure.zip,
          f.departure.city,
        ]
          .filter((e) => e !== undefined)
          .join(" ");
      },
    },
    {
      title: "Adresse Arrivée",
      render: (f) => {
        return [
          f.arrival.placeName,
          f.arrival.address,
          f.arrival.zip,
          f.arrival.city,
        ]
          .filter((e) => e !== undefined)
          .join(" ");
      },
    },
    {
      title: "Péage",
      render: (f) => (f.toll ? "" + f.toll : "non"),
    },
  ];

  const onRowClick = (fare: Fare) => {
    props.onRowClick(fare);
  };
  const classes = ListStyles();

  const getRow = (index: number, fare: Fare) => {
    return (
      <TableRow
        className={classes.tableRow}
        key={fare.identifier}
        onClick={() => onRowClick(fare)}
        style={{
          height: "50px",
          cursor: "pointer",
          transition: "background-color 0.2 linear",
          background: index % 2 ? "#EEEEEE" : "#ffffff",
        }}
      >
        {cols.map((c) => (
          <TableCell key={fare.identifier + c.title}>
            {c.render(fare)}
          </TableCell>
        ))}
      </TableRow>
    );
  };

  const getHeaders = () => {
    return (
      <TableHead>
        <TableRow>
          {cols.map((c) => (
            <TableCell key={c.title}>{c.title}</TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  };

  return (
    <TableContainer component={Paper}>
      <Table size="small">
        {getHeaders()}
        <TableBody>{props.fares.map((f, i) => getRow(i, f))}</TableBody>
      </Table>
    </TableContainer>
  );
};

export default FareTable;
